import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController, NavParams } from '@ionic/angular';
import { QuillModules } from 'ngx-quill';
import { HelperService } from 'src/app/services';

export interface INote {
  title: string;
  note: string;
}

@Component({
  selector: 'app-notes',
  templateUrl: './notes.page.html',
  styleUrls: ['./notes.page.scss'],
})

export class NotesPage implements OnInit {

  public action: "edit" | "view";
  public activeNote: any;
  public activeNoteIndex: number;
  public notes: string[];
  public editableNotes: Array<INote>;;
  public type: string;
  public defaultNotes: Array<INote> | Array<string>;
  public editorModules: QuillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],  
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults
      [{ 'align': [] }],
    ]
  };
  constructor(
    private alertController: AlertController,
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private helperService: HelperService,
  ) {
    this.defaultNotes = navParams.get('defaultNotes'); 
    this.action = navParams.get('action'); 
    this.notes = navParams.get('notes') || []; 
    this.type = navParams.get('type') || null; 
  }

  ngOnInit() {
    if(this.notes && this.notes.length > 0) {
      if(typeof this.notes[0] === "string") {
        this.editableNotes = [{title: "General", note: this.convertNotes(this.notes)}];
      } else {
        this.editableNotes = this.helperService.copyObject(this.notes);
      }
    } else {
      this.editableNotes = [{title: "General", note: ""}];
    }
    if(this.defaultNotes && this.defaultNotes.length > 0 && typeof this.defaultNotes[0] === 'string') {
      this.defaultNotes = [{title: "General", note: this.convertNotes(this.defaultNotes)}];
    }
    this.setActiveNote(0);
  }

  convertNotes(notes: any) {
    let noteString = "<ul>"
    for (const note of notes) {
      noteString += `<li>${note}</li>`
    }
    noteString += "</ul>";
    return noteString
  }

  getTitle() {
    switch (this.type) {
      case "meal":
        return "Meal "
      case "mealPlan":
          return "Meal Plan "
      case "workoutProgram":
          return "Training Program "
      case "supplementProtocol":
          return "Supplement Protocol "
      case "cardioProgram":
          return "Cardio Program "
      default:
          return ""
    }
  }

  submitNotes() {   
    this.modalCtrl.dismiss({ 
      status: "submitted",
      data: this.helperService.copyObject(this.editableNotes),     
    });
  }

  setDefaultNotes() {
    if(this.defaultNotes && this.defaultNotes.length > 0) {
      this.editableNotes = this.helperService.copyObject(this.defaultNotes);
      this.setActiveNote(0);
    }
  }

  onCancel() {
    this.modalCtrl.dismiss();
  }

  async setTitle(index) {
    const alert = await this.alertController.create({
      header: 'Category Title',
      inputs: [
        {
          name: 'categoryTitle',
          type: 'text',
          placeholder: 'e.g. Vitamins / Minerals',
          value: this.editableNotes[index].title || "",
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {}
        }, {
          text: 'Ok',
          handler: async (values) => {
            if(values.categoryTitle) {
              this.editableNotes[index].title = values.categoryTitle;
            } else {
              const failAert = await this.alertController.create({
                header: 'Note Title Missing',
                message: 'You must enter a category title',
                buttons: ['OK']
              });
              await failAert.present();
            }
          }
        }
      ]
    });
    await alert.present();
  }

  async newNote() {
    const alert = await this.alertController.create({
      header: 'Category Title',
      inputs: [
        {
          name: 'categoryTitle',
          type: 'text',
          placeholder: 'e.g. Vitamins / Minerals'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {}
        }, {
          text: 'Ok',
          handler: async (values) => {
            if(values.categoryTitle) {
              this.addNote(values.categoryTitle);
              this.setActiveNote(this.editableNotes.length - 1);
            } else {
              const failAert = await this.alertController.create({
                header: 'Note Title Missing',
                message: 'You must enter a category title',
                buttons: ['OK']
              });
              await failAert.present();
            }
          }
        }
      ]
    });
    await alert.present();
  }

  addNote(title: string) {
    this.editableNotes.push({
      title: title,
      note: ""
    });
  }

  setActiveNote(index) {
    this.activeNote = this.editableNotes[index];
    this.activeNoteIndex = index;
  }

  duplicateNote(category) {
    this.editableNotes.push(this.helperService.copyObject(category));
    this.setActiveNote(this.editableNotes.length - 1);
  }

  deleteNote(index) {
    this.editableNotes.splice(index, 1);
    this.setActiveNote(this.editableNotes.length - 1);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.editableNotes, event.previousIndex, event.currentIndex);
    this.setActiveNote(event.currentIndex)
  }
}
